<template>
  <div>
    <Button @click="openDetailPrdDialog()" icon="pi pi-eye" text rounded></Button>
    <Dialog position="top" :draggable="false" v-model:visible="detailProductModal" modal header="Đặc tính sản phẩm"
      :style="{ width: '900px' }">
      <div class="flex flex-column gap-4">
        <strong>Thông tin chung</strong>
        <div class="grid">
          <div class="col-3">
            <div class="w-full">
              <img class="w-full" :src="detailGoods.itM1 ? detailGoods.itM1[0].filePath : ''" />
            </div>
          </div>
          <div class="col-9 flex flex-column gap-3">
            <div class="flex flex-column gap-2">
              <label for="">Mã sản phẩm</label>
              <InputText readonly v-model="detailGoods.itemCode"></InputText>
            </div>
            <div class="flex flex-column gap-2">
              <label for="">Tên sản phẩm</label>
              <InputText readonly v-model="detailGoods.itemName"></InputText>
            </div>
            <div class="flex flex-column gap-2">
              <label for="">Mô tả</label>
              <Textarea readonly v-model="detailGoods.note" autoResize rows="5"></Textarea>
            </div>
          </div>
        </div>
        <strong>Thông tin theo yêu cầu</strong>
        <div class="grid">
          <div class="col flex flex-column gap-3">
            <div class="flex flex-column gap-2">
              <label for="">Nguyên liệu vàng</label>
              <Dropdown placeholder="--Chọn nguyên liệu--"></Dropdown>
            </div>
            <div class="flex flex-column gap-2">
              <label for="">Kích thước sản phẩm</label>
              <Dropdown placeholder="--Chọn kích thước--"></Dropdown>
            </div>
          </div>
          <div class="col flex flex-column gap-3">
            <div class="flex flex-column gap-2">
              <label for="">Giá vàng</label>
              <InputNumber></InputNumber>
            </div>
            <div class="flex flex-column gap-2">
              <label for="">Loại đá</label>
              <Dropdown placeholder="--Chọn loại đá--"></Dropdown>
            </div>
          </div>
          <div class="col flex flex-column gap-3">
            <div class="flex flex-column gap-2">
              <label for="">Trọng lượng yêu cầu (gr)</label>
              <InputNumber></InputNumber>
            </div>

            <div class="flex flex-column gap-2">
              <label for="">Kích thước đá</label>
              <Dropdown placeholder="--Chọn kích thước--"></Dropdown>
            </div>
          </div>
        </div>
        <Textarea autoResize placeholder="Yêu cầu khác..."></Textarea>

        <strong>Thông tin dịch vụ</strong>
        <div class="flex flex-column gap-2">
          <label for="">Mã dịch vụ</label>
          <Dropdown placeholder="--Chọn mã--"></Dropdown>
        </div>
      </div>
      <template #footer>
        <div class="flex gap-2">
          <Button label="Bỏ qua" @click="detailProductModal = false" outlined />
          <Button label="Xác nhận"></Button>
        </div>
      </template>
    </Dialog>
  </div>
</template>
<script setup>
import { ref } from "vue";
import API from "../../../api/api-main";
const detailProductModal = ref(false);
const detailGoods = ref([]);
const props = defineProps({
  data: Object,
});

const openDetailPrdDialog = async () => {
  try {
    const res = await API.get(`Item/${props.data.id ? props.data.id : props.data.itemId}`);
    detailGoods.value = res.data;
  } catch (error) {
    console.log(error);
  }
  detailProductModal.value = true;
};
</script>
<style></style>
